import {
  GET_SPORTSBOOK_EVENTS_HASH_REQUEST,
  GET_SPORTSBOOK_EVENTS_HASH_SUCCESS,
  GET_SPORTSBOOK_EVENTS_HASH_FAILURE,
  REST_SPORTSBOOK_EVENTS_HASH,
  SPORTSBOOK_EVENTS_WS_UPDATE,
  SPORTSBOOK_EVENTS_WS_REMOVE
} from 'Store/constants';

export const initialState = {
  groupedEvents: {},
  marketGroups: {},
  events: {},
  onComingEvents: {},
  groupedFilters: {},
  availableFilters: {},
  isLoading: false,
  isFetched: false,
  isAntepost: null,
  removedEventCount: 0
};

export default (state = initialState, action) => {

  switch (action.type) {
    case GET_SPORTSBOOK_EVENTS_HASH_REQUEST: {
      const { showLoading } = action.payload;
      
      return {
        ...state,
        isLoading: showLoading ? true : state.isLoading,
        isFetched: showLoading ? false : state.isFetched,
        removedEventCount: 0
      };
    }

    case GET_SPORTSBOOK_EVENTS_HASH_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isFetched: true,
        removedEventCount: 0
      };
    }

    case GET_SPORTSBOOK_EVENTS_HASH_FAILURE: {
      return {
        ...state,
        isLoading: false,
        isFetched: true,
        removedEventCount: 0
      };
    }

    case SPORTSBOOK_EVENTS_WS_UPDATE: {
      const { eventId, newEvent, isOnComingEvent } = action.payload;

      if (isOnComingEvent) {
        return {
          ...state,
          onComingEvents: {
            ...state.onComingEvents,
            [eventId]: { ...newEvent },
          },
        };
      } else {
        return {
          ...state,
          events: {
            ...state.events,
            [eventId]: { ...newEvent },
          },
        };
      }
    }


    case SPORTSBOOK_EVENTS_WS_REMOVE: {
      //removed event count tut.
      const { eventId, isOnComingEvent } = action.payload;

      if (isOnComingEvent) {
        return {
          ...state,
          onComingEvents: {
            ...state.onComingEvents,
            [eventId]: {
              ...state.onComingEvents[eventId],
              isRemovedFromSocket: true,
            },
          },
          removedEventCount: state.removedEventCount + 1,
        };
      } else {
        return {
          ...state,
          events: {
            ...state.events,
            [eventId]: {
              ...state.events[eventId],
              isRemovedFromSocket: true,
            },
          },
          removedEventCount: state.removedEventCount + 1,
        };
      }
    }

    case REST_SPORTSBOOK_EVENTS_HASH: {
      return {
        ...initialState,
      };
    }

    default:
      return state;
  }
};
